module.exports = __webpack_public_path__ + "static/media/20a.e63c87c2.jpg";